(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["footer-directory-group"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('footer-directory')) {
    customElements.define('footer-directory', class extends HTMLElement {
      connectedCallback() {
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.sync = () => {
          this.querySelectorAll('details').forEach((details) => {
            details.open = !this.mobile.matches;
            const summary = details.querySelector('summary');
            if (this.mobile.matches) summary.removeAttribute('tabindex');
            else summary.setAttribute('tabindex', '-1');
          });
        };
        this.keepOpen = (event) => {
          if (!this.mobile.matches && event.target.closest('summary')) event.preventDefault();
        };
        this.mobile.addEventListener('change', this.sync);
        this.addEventListener('click', this.keepOpen);
        this.sync();
      }
      disconnectedCallback() {
        this.mobile.removeEventListener('change', this.sync);
        this.removeEventListener('click', this.keepOpen);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
